<template>
  <div class="marketing-email-list">
    <v-data-table class="marketing-email-list-table"
                  :headers="headers"
                  :items="emailList"
                  :loading="loading"
                  :hide-actions="true"
                  :no-data-text="$t('message.generics.message.noResultsFound')"
                  :no-results-text="$t('message.generics.message.noResultsFound')"
                  disable-initial-sort>

      <template slot="items"
                slot-scope="props">
        <marketing-email-list-item :item="props.item"
                                   :is-automation="filter.isAutomation"
                                   @resent="reloadListAndTotal"
                                   @duplicated="reloadList"
                                   @deleted="reloadList"
                                   @edited="reloadList" />
      </template>
    </v-data-table>

    <infinite-loading :identifier="infiniteId"
                      @infinite="fetchList">
      <div slot="no-results"></div>
      <div slot="no-more"></div>
    </infinite-loading>
  </div>
</template>

<script>
import MarketingEmailListItem from "@components/modules/marketing/email/list/item/MarketingEmailListItem";
import EventBus from "@packages/event-bus";
import InfiniteLoading from "vue-infinite-loading";

export default {
  components: {
    MarketingEmailListItem,
    InfiniteLoading,
  },
  data() {
    return {
      loading: false,
      emailList: [],
      infiniteId: +new Date(),
      filter: {
        page: 0,
        filter: "",
        isAutomation: false,
      },
    };
  },
  props: {},

  computed: {
    headers() {
        return [
            { text: this.$t('message.generics.message.status'), value: "status", sortable: false },
            { text: this.$t('message.generics.message.name'), value: "title", sortable: false },
            { text: this.$t('message.marketingGenerics.message.sendDate'), value: "sentDate", sortable: true },
            { text: this.$t('message.marketingGenerics.message.numberSent'), value: "sendingAmount", sortable: true },
            { text: this.$t('message.email.message.opened'), value: "opened", sortable: true },
            { text: this.$t('message.email.message.clicks'), value: "clicked", sortable: true },
            { text: this.$t('message.email.message.bounces'), value: "bounced", sortable: true },
            { text: this.$t('message.marketingGenerics.message.actions'), value: "", sortable: false },
        ]
    }
  },
  created() {
    EventBus.$on("EMAIL_SET_SEARCH", this.searchList);
    EventBus.$on("EMAIL_SMS_LIST_TAB", this.setIsAutomationAndReload);
  },
  beforeDestroy() {
    EventBus.$off("EMAIL_SET_SEARCH", this.searchList);
    EventBus.$off("EMAIL_SMS_LIST_TAB", this.setIsAutomationAndReload);
  },
  methods: {
    setIsAutomationAndReload(value) {
      this.filter.isAutomation = value;

      this.reloadList();
    },
    reloadListAndTotal() {
      this.reloadList();
    },
    async searchList(search) {
      this.filter.filter = search;
      this.reloadList();
    },
    async reloadList() {
      this.filter.page = 0;
      this.emailList = [];

      this.infiniteId++;
    },
    async fetchList($state) {
      this.loading = true;

      const emailList = await this.$api.marketing.email.message.list({
        page: this.filter.page,
        filter: this.filter.filter,
        isAutomation: this.filter.isAutomation,
      });

      if (emailList.length) {
        this.filter.page += 1;

        this.emailList.push(...emailList);

        if ($state) {
          $state.loaded();
        }
      } else {
        if ($state) {
          $state.complete();
        }
      }

      this.loading = false;
    },
  },
};
</script>

<style lang="scss" scoped>
.marketing-email-list {
  .marketing-email-list-table {
    ::v-deep .v-table__overflow {
      padding-bottom: 100px;
    }
  }
}
</style>
